import { Outlet } from "react-router-dom";
import NavDropdown from "../../components/nav/NavDropdown";
import { useContext } from "react";
import { UserQueryContext } from "../../context/UserContext";
import AccessDenied from "../../components/AccessDenied";

export default function EfteruddannelseLayout() {
  const { user, hasPermission } = useContext(UserQueryContext);
  if (!hasPermission(user, "TilsynRead")) return <AccessDenied />;

  return (
    <>
      <meta name="theme-color" content="#00a546" />
      <div className="l-main">
        <header className="navbar">
          <NavDropdown />
        </header>
        <Outlet />
      </div>
    </>
  );
}
